import { render, staticRenderFns } from "./ExploreMore.vue?vue&type=template&id=04229970"
import script from "./ExploreMore.vue?vue&type=script&lang=js"
export * from "./ExploreMore.vue?vue&type=script&lang=js"
import style0 from "./ExploreMore.vue?vue&type=style&index=0&id=04229970&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports